



























import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";
import Confirm from "@/shared/components/confirm.vue";
import { ConsultoresService } from "@/services/consultores.service";
import { validDate } from "@/shared/validators";
import DatePicker from "@/shared/components/date-picker.vue";

@Component({
  components: {
    DataTable,
    Confirm,
    PlanosAba,
    DatePicker,
  },
})
export default class DataUtilizacaoAplicativo extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  loading = false;
  senha: string | null = "";
  showSucess?: boolean = false;
  dataLimiteUtilizaAplicativo: string | null = "";
  showError?: boolean = false;
  msgData: string | null = "";
  data: string | null = "";

  rules = {
    data: [validDate()],
  };

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.loading = true;
    try {
      this.data = await ConsultoresService.ObterDataUtilizacaoAplicativo(
        this.idConsultor
      );
    } finally {
      this.loading = false;
    }
  }

  async AlterarData() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.startLoader();

      const dataEnvio = this.data!.split("/").reverse().join("-");

      await ConsultoresService.AlterarDataUtilizaAplicativo(
        this.idConsultor,
        dataEnvio
      ).finally(this.stopLoader);

      this.msgData = "Data alterada com sucesso";
      this.showSucess = true;
      setTimeout(this.fechaAlertaStatus, 5000);
    }
  }

  fechaAlertaStatus() {
    this.showSucess = false;
    this.showError = false;
  }
}
